// Redirect deprecated paths to canonical /revcal before loading the app
const DEPRECATED_PATH_REDIRECTS: Record<string, string> = {
  '/fba/revenuecalculator': '/revcal',
  '/fba/profitabilitycalculator': '/revcalpublic',
  '/hz/fba/profitabilitycalculator': '/revcalpublic',
};

const currentPath = window.location.pathname;
const matchedOldPath = Object.keys(DEPRECATED_PATH_REDIRECTS).find(
  (oldPath) => currentPath === oldPath || currentPath.startsWith(oldPath + '/'),
);

if (matchedOldPath) {
  // Preserve query string and hash, use replace() to avoid back-button loop
  const newUrl =
    DEPRECATED_PATH_REDIRECTS[matchedOldPath] +
    window.location.search +
    window.location.hash;
  window.location.replace(newUrl);
} else {
  // Only load the app if we're not redirecting
  import('./bootstrap');
}

/* Following: https://code.amazon.com/reviews/CR-158271723/revisions/2#/details
 * We now put the whole (old) index.tsx into an async context, to fix the bug "Shared module is not available for eager consumption"
 * that's caused by Federation one. It will try to load the component even before main page is loaded on standalone pages.
 */
